import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { DragSource as dragSource } from 'react-dnd'

import { showModal } from 'actions/common'
import { gridRemoveTicket, gridSetCurrentEditingSellableItem } from 'actions/grid'
import { GRID_DND_SIDEBAR_SELLABLE_ITEM } from 'constants/grid-constants'
import { GRID_TICKET_MODAL } from 'constants/modal-constants'

import GridSidebarSellableItem from './grid-sidebar-sellable-item'

class GridSidebarSellableItemContainer extends Component {

  constructor(props) {
    super(props)

    this.onEdit = this.onEdit.bind(this)
    this.onRemove = this.onRemove.bind(this)
  }

  onEdit() {
    this.props.gridSetCurrentEditingSellableItem(this.props.sellableItem.id)
    this.props.showModal(GRID_TICKET_MODAL)
  }

  onRemove() {
    this.props.gridRemoveTicket(this.props.sellableItem.id)
  }

  render() {
    const { connectDragSource } = this.props

    return connectDragSource(
      <div>
        <GridSidebarSellableItem {...this.props} onEdit={this.onEdit} onRemove={this.onRemove} />
      </div>
    )
  }
}

GridSidebarSellableItemContainer.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  gridRemoveTicket: PropTypes.func.isRequired,
  gridSetCurrentEditingSellableItem: PropTypes.func.isRequired,
  sellableItem: PropTypes.object.isRequired,
  showModal: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
  gridRemoveTicket,
  gridSetCurrentEditingSellableItem,
  showModal,
}

const sidebarSellableItemSource = {
  beginDrag(props) {
    return {
      sellableItem: props.sellableItem,
    }
  },
}

const collect = (sourceConnect, monitor) => ({
  connectDragSource: sourceConnect.dragSource(),
  isDragging: monitor.isDragging(),
})

const DNDContainer = dragSource(
  GRID_DND_SIDEBAR_SELLABLE_ITEM,
  sidebarSellableItemSource,
  collect
)(GridSidebarSellableItemContainer)

export default connect(undefined, mapDispatchToProps)(DNDContainer)



/** WEBPACK FOOTER **
 ** ./src/components/grid-sidebar/grid-sidebar-sellable-item/grid-sidebar-sellable-item-container.js
 **/